export type DeviceDto = {
  id: number;
  deviceName: string;
  description: string;
  serialNumber: string;
  parserConfigId: number;
  parserConfigName: string;
  deviceTypeId: number;
  deviceTypeName: string;
  iconId: number;
  deviceGroupId?: number;
  deviceGroupName?: string;
  canEdit?: boolean;
  canDelete?: boolean;
};

export type DevicePaginateRequest = {
  page: number;
  pageSize: number;
  filter: string;
  deviceTypeId?: number;
};

export type CreateDeviceRequest = {
  deviceName: string;
  description: string;
  serialNumber: string;
  parserConfigId: number;
  deviceTypeId: number;
  iconId: number;
  deviceGroupId: number | null;
};

export type UpdateDeviceRequest = CreateDeviceRequest & {
  id: number;
};

export enum DeviceTypeId {
  Sensor = 1,
  Gateway = 2,
}
